import React from 'react';

const SvgCm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect
        id="CM_svg__a"
        x={0}
        y={0}
        width="1em"
        height="1em"
        viewBox="0 0 28 20"
        rx={2}
      />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="CM_svg__b">
        <stop stopColor="#FFDC44" offset="0%" />
        <stop stopColor="#FDD216" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CM_svg__c" fill="#fff">
        <use xlinkHref="#CM_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#CM_svg__a" />
      <path
        fill="url(#CM_svg__b)"
        mask="url(#CM_svg__c)"
        d="M13.333 0H28v20H13.333z"
      />
      <path fill="#059170" mask="url(#CM_svg__c)" d="M0 0h9.333v20H0z" />
      <path
        fill="#E21A30"
        mask="url(#CM_svg__c)"
        d="M9.333 0h9.333v20H9.333z"
      />
      <path fill="#FFDC44" mask="url(#CM_svg__c)" d="M18.667 0H28v20h-9.333z" />
      <path
        fill="#FFDC42"
        mask="url(#CM_svg__c)"
        d="M14 11.3l-1.96 1.397.724-2.295L10.83 8.97l2.406-.022L14 6.667l.764 2.281 2.406.022-1.934 1.432.723 2.295z"
      />
    </g>
  </svg>
);

export default SvgCm;
